import React, { type ComponentType, type FC } from 'react';
import { Subscribe } from 'unstated';

import { GuestSatisfactionSurveyStateContainer } from '@confluence/external-collab-ui';

export type WithSatisfactionSurveyProps = {
	guestSatisfactionSurveyState: GuestSatisfactionSurveyStateContainer;
};

export function withSatisfactionSurveys<T>(
	WrappedComponent: ComponentType<T & WithSatisfactionSurveyProps>,
): FC<Omit<T, keyof WithSatisfactionSurveyProps>> {
	function withSatisfactionSurveys(props) {
		return (
			<Subscribe to={[GuestSatisfactionSurveyStateContainer]}>
				{(guestSatisfactionSurveyState: GuestSatisfactionSurveyStateContainer) => (
					<WrappedComponent
						guestSatisfactionSurveyState={guestSatisfactionSurveyState}
						{...props}
					/>
				)}
			</Subscribe>
		);
	}
	return withSatisfactionSurveys;
}
